module.exports = __webpack_public_path__ + "static/media/scorecards_design.eaa9128e.png";